import { makeStyles } from '@mui/styles';

export const useKioskConnectivityStatusIconStyles = (props: {
  color: KioskConnectivityStatusIconColor;
  pulse: boolean;
}) =>
  makeStyles(() => ({
    icon: {
      borderRadius: '50%',
      backgroundColor: colorMap[props.color].default,
      height: '18px',
      width: '18px',
      boxShadow: colorMap[props.color].default,
      filter: 'brightness(1)',
      transform: 'scale(1)',
      animation: props.pulse ? '$pulse 2s infinite' : undefined
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(0.95)',
        boxShadow: `0 0 0 0 ${colorMap[props.color]['0%']}`,
        filter: 'brightness(1.5)'
      },

      '70%': {
        transform: 'scale(1)',
        boxShadow: `0 0 0 10px ${colorMap[props.color]['70%']}`,
        filter: 'brightness(2)'
      },

      '100%': {
        transform: 'scale(0.95)',
        boxShadow: `0 0 0 0 ${colorMap[props.color]['100%']}`,
        filter: 'brightness(1)'
      }
    }
  }))();

export type KioskConnectivityStatusIconColor = 'green' | 'orange' | 'red' | 'grey';

const colorMap: Record<
  KioskConnectivityStatusIconColor,
  { default: string; '0%': string; '70%': string; '100%': string }
> = {
  green: {
    default: 'rgba(52, 174, 167, 1)',
    '0%': 'rgba(52, 174, 167, 0.7)',
    '70%': 'rgba(52, 174, 167, 0)',
    '100%': 'rgba(52, 174, 167, 0)'
  },
  orange: {
    default: 'rgba(229, 116, 1, 1)',
    '0%': 'rgba(229, 116, 1, 0.7)',
    '70%': 'rgba(229, 116, 1, 0)',
    '100%': 'rgba(229, 116, 1, 0)'
  },
  red: {
    default: 'rgba(219, 46, 45, 1)',
    '0%': 'rgba(219, 46, 45, 0.7)',
    '70%': 'rgba(219, 46, 45, 0)',
    '100%': 'rgba(219, 46, 45, 0)'
  },
  grey: {
    default: 'rgba(132, 132, 132, 1)',
    '0%': 'rgba(132, 132, 132, 0.7)',
    '70%': 'rgba(132, 132, 132, 0)',
    '100%': 'rgba(132, 132, 132, 0)'
  }
};
